import { getEsgCategories } from '@lib/api/index';
// import { fetchData } from '@lib/helpers/index';
// import StatusBar from 'components/wizard/StatusBar';
import React, { useEffect, useState } from 'react';

import { Button, Form, Spinner } from 'react-bootstrap';
import CounterComponent from './CounterComponent';
import Category from './CategoriesItems';
import { idDependsOnAnswerFullfilled, updateAnswersData } from '@lib/helpers/questionnaireHelpers';

const EsgComponent = ({
  questionsData,
  answersData,
  setAnswersData,
  postFunction,
  isLoading,
  sbShow,
  formId = 'form-subesg',
  shouldStick = true,
  shouldAnswerAll = false,
  userRole = null,
  translations,
  isButtonVisible,
  areInputsDisabled = false,
  isMonitoring = false,
}) => {
  const [esgCategories, setEsgCategories] = useState([]);
  const [esgSubCategories, setEsgSubCategories] = useState([]);
  const [dependsOnAnswers, setDependsOnAnswers] = useState([]);

  const [questionVisibility, setQuestionVisibility] = useState(() => {
    if (!questionsData) return {};
    const initialVisibility = {};
    questionsData.forEach((question) => {
      if (Array.isArray(question.dependsOnAnswers) && question.dependsOnAnswers.length > 0) {
        const allAnswersPresent = question.dependsOnAnswers.every((answerId) => {
          return answersData.some((a) =>
            a.answers.some((ans) => ans.answerId === answerId && ans.value === 'on'),
          );
        });
        initialVisibility[question.questionId] = allAnswersPresent;
      } else {
        initialVisibility[question.questionId] = true;
      }
    });
    return initialVisibility;
  });

  useEffect(() => {
    getEsgCategories().then((retrievedCategories) => {
      setEsgCategories(retrievedCategories);
      setEsgSubCategories(retrievedCategories.map((category) => category.esgsubcategories).flat());
    });
  }, []);

  useEffect(() => {
    if (!questionsData) return;
    idDependsOnAnswerFullfilled(questionsData, setDependsOnAnswers);
  }, [questionsData]);

  const handleAssessmentChange = (e, questionId, answerId, type) => {
    setAnswersData((prevAnswers) => {
      const finalAnswers = updateAnswersData(
        prevAnswers,
        e,
        questionId,
        answerId,
        type,
        dependsOnAnswers,
      );

      if (JSON.stringify(finalAnswers) === JSON.stringify(prevAnswers)) {
        return prevAnswers;
      }

      return finalAnswers;
    });
  };

  useEffect(() => {
    if (!questionsData) return;
    const updatedVisibility = {};
    questionsData.forEach((question) => {
      if (Array.isArray(question.dependsOnAnswers) && question.dependsOnAnswers.length > 0) {
        const allAnswersPresent = question.dependsOnAnswers.every((answerId) => {
          return answersData.some((a) =>
            a.answers.some((ans) => ans.answerId === answerId && ans.value === 'on'),
          );
        });
        updatedVisibility[question.id] = allAnswersPresent;
      } else {
        updatedVisibility[question.id] = true;
      }
    });
    setQuestionVisibility(updatedVisibility);
  }, [answersData, questionsData]);

  const handleChecked = (questionID, answerID) => {
    let boolean = false;
    answersData.forEach((el) => {
      if (Number(el.questionId) === questionID) {
        const checkedAnswers = el.answers.find((answer) => answer.answerId === answerID);
        if (checkedAnswers && checkedAnswers?.value === 'on') {
          boolean = true;
        } else {
          boolean = false;
        }
      }
    });
    return boolean;
  };

  const handleValue = (questionID, answerID) => {
    const question = answersData.find((el) => el.questionId === questionID);
    return question?.answers.find((ans) => ans.answerId === answerID)?.value || '';
  };

  return (
    <div className='mt-2'>
      <div className='d-flex justify-content-between'>
        <h5 className='title-simple-box margin-title-box'>ESG</h5>
        <CounterComponent
          answeredNumber={answersData.length}
          toAnswerNumber={
            questionVisibility &&
            Object.keys(questionVisibility)
              .map((key) => questionVisibility[key])
              .filter((el) => el === true).length
          }
        />
      </div>

      <div>
        <Form onSubmit={postFunction} id={formId}>
          {esgCategories
            ?.sort((a, b) => a.order - b.order)
            ?.map((category) => (
              <Category
                key={category.code}
                category={category}
                subCategories={esgSubCategories}
                questions={questionsData}
                handleAssessmentChange={handleAssessmentChange}
                questionVisibility={questionVisibility}
                handleValue={handleValue}
                handleChecked={handleChecked}
                userRole={userRole}
                translations={translations}
                assessment={answersData}
                areInputsDisabled={areInputsDisabled}
                isMonitoring={isMonitoring}
              />
            ))}
          {isButtonVisible && (
            <Button
              form={formId}
              id='save-general-button'
              type='submit'
              className={`submit-button ${shouldStick ? 'sticky-footer-button' : ''}`}
              disabled={
                shouldAnswerAll
                  ? isLoading ||
                    Object.keys(questionVisibility)
                      .map((key) => questionVisibility[key])
                      .filter((el) => el === true).length !== answersData.length ||
                    userRole === 4
                  : isLoading || userRole === 4
              }>
              {!isLoading ? (
                'SALVA'
              ) : (
                <span className='d-flex align-items-center' style={{ gap: '0.5rem' }}>
                  Caricamento
                  <Spinner animation='border' size='sm' />
                </span>
              )}
            </Button>
          )}
        </Form>
      </div>
      {sbShow}
      {/* {error && <StatusBar status={'error'} message={error} timeout={false} />} */}
    </div>
  );
};

export default EsgComponent;
